// extracted by mini-css-extract-plugin
export var anchored = "OverlappingHero-module--anchored--c56f3";
export var anywhere = "OverlappingHero-module--anywhere--2e66c";
export var bleed = "OverlappingHero-module--bleed--f270a";
export var center = "OverlappingHero-module--center--5da26";
export var copy = "OverlappingHero-module--copy--001a3";
export var emerald = "OverlappingHero-module--emerald--4d791";
export var gold = "OverlappingHero-module--gold--31982";
export var grey = "OverlappingHero-module--grey--7a752";
export var grid = "OverlappingHero-module--grid--0b341";
export var hasBackground = "OverlappingHero-module--has-background--09717";
export var headingSuper = "OverlappingHero-module--heading-super--15882";
export var hero = "OverlappingHero-module--hero--4b7e7";
export var heroImage = "OverlappingHero-module--hero-image--d7e3b";
export var lilac = "OverlappingHero-module--lilac--5cd45";
export var noPad = "OverlappingHero-module--no-pad--612fd";
export var padAdjust = "OverlappingHero-module--pad-adjust--f71a8";
export var paragraph = "OverlappingHero-module--paragraph--a12eb";
export var useH1 = "OverlappingHero-module--use-h1--b151a";
export var videoAdjust = "OverlappingHero-module--video-adjust--85dc9";
export var widerText = "OverlappingHero-module--wider-text--241c4";
export var wistiaWrap = "OverlappingHero-module--wistia-wrap--54a12";
export var workforce = "OverlappingHero-module--workforce--1fa14";
export var wrap = "OverlappingHero-module--wrap--2eaaf";